import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

if (!localStorage.getItem("i18nextLng")) {
  localStorage.setItem("i18nextLng", "uz");
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    fallbackLng: "uz",
    debug: true,
    detection: {
      order: ["queryString", "localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    const lng = localStorage.getItem("i18nextLng");
    if (lng && lng.includes("-")) {
      const [language] = lng.split("-");
      i18next.changeLanguage(language);
      localStorage.setItem("i18nextLng", language);
    }
  });

export default i18next;
export const changeLanguage = (lang) => {
  i18next.changeLanguage(lang);
  localStorage.setItem("i18nextLng", lang);
};
